export default "<p>dashboard-commercial-imputations-to-validate works!</p>\r\n";